module.exports = __webpack_public_path__ + "img/blog-1.002f172b.webp";